<template>
	<div>
		<a
			href="#"
			class="underline"
			@click="openMapPreview">
			{{ linkTitle }}
		</a>
		<ProductPreviewMap
			:title="title"
			:body="body"
			:image-src="imageSrc"
			ref="mapPreviewRef" />
	</div>
</template>

<script setup>
	defineProps({
		linkTitle: String,
		title: String,
		body: String,
		imageSrc: String,
	})

	const mapPreviewRef = ref(null)
	const openMapPreview = () => {
		mapPreviewRef.value?.openModal()
	}
</script>

<style scoped></style>
